var map = {
	"./champions_league.embedded.svg": 1212,
	"./conmebol_icon.embedded.svg": 1213,
	"./csgo_icon.embedded.svg": 1214,
	"./dota2_icon.embedded.svg": 1215,
	"./dreamhack_icon.embedded.svg": 1216,
	"./esl_icon.embedded.svg": 1217,
	"./fnatic_icon.embedded.svg": 1218,
	"./i_league_icon.embedded.svg": 1219,
	"./logo-12up.embedded.svg": 527,
	"./logo-90min.embedded.svg": 528,
	"./logo-dbltap.embedded.svg": 529,
	"./logo-ei.embedded.svg": 530,
	"./logo-floor8.embedded.svg": 531,
	"./logo-ftb90.embedded.svg": 532,
	"./logo-german_site.embedded.svg": 533,
	"./logo-ht_media.embedded.svg": 534,
	"./logo-pluralist.embedded.svg": 535,
	"./lol_icon.embedded.svg": 1220,
	"./mdl_icon.embedded.svg": 1221,
	"./melee_icon.embedded.svg": 1222,
	"./mlb_icon.embedded.svg": 1223,
	"./mls_icon.embedded.svg": 1224,
	"./nba_icon.embedded.svg": 1225,
	"./ncaa-basketball_icon.embedded.svg": 1226,
	"./ncaa-football_icon.embedded.svg": 1227,
	"./nfl_icon.embedded.svg": 1228,
	"./overwatch_icon.embedded.svg": 1229,
	"./powered-by-ei.embedded.svg": 536,
	"./powered-by-german_site.embedded.svg": 537,
	"./powered-by-ht_media.embedded.svg": 538,
	"./smash4_icon.embedded.svg": 1230,
	"./streetfighter_icon.embedded.svg": 1231
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1242;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1242
// module chunks = 6